/* KartComms — Setup Finder quiz engine.
   Client-side branching: intro → 4 questions → recommendation. No reload, no signup. */
(function () {
  'use strict';
  var root = document.getElementById('kc-quiz');
  if (!root) return;

  var dataEl = root.querySelector('#kc-quiz-data');
  var PRODUCTS = {};
  try { PRODUCTS = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var I18N = {};
  try { I18N = JSON.parse(root.querySelector('#kc-quiz-i18n').textContent); } catch (e) {}

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var QORDER = ['q1', 'q2', 'q3', 'q4'];           // screen ids in question order
  var screens = {};
  root.querySelectorAll('.kcq-screen').forEach(function (s) { screens[s.dataset.screen] = s; });
  var progress = root.querySelector('[data-progress]');
  var progLabel = root.querySelector('[data-progress-label]');
  var segs = Array.prototype.slice.call(root.querySelectorAll('.kcq-progress__seg'));

  var answers = {};            // { people, p2d, endurance, storage }
  var current = 'intro';

  /* ---------- screen navigation ---------- */
  function show(id, back) {
    var next = screens[id];
    if (!next) return;
    var prev = screens[current];
    if (prev && prev !== next) { prev.classList.remove('is-active', 'is-back'); }
    next.classList.toggle('is-back', !!back && !reduce);
    // force the entrance animation to replay
    next.classList.remove('is-active'); void next.offsetWidth; next.classList.add('is-active');
    current = id;

    var qIndex = QORDER.indexOf(id);
    if (qIndex > -1) {
      progress.hidden = false;
      var n = qIndex + 1;
      var ptpl = I18N.progress || 'Question {n} / 04';
      progLabel.textContent = ptpl.replace('{n}', (n < 10 ? '0' + n : '' + n));
      segs.forEach(function (seg, i) {
        seg.classList.toggle('is-on', i <= qIndex);
        seg.classList.toggle('is-current', i === qIndex);
      });
    } else {
      progress.hidden = true;
    }
    // reflect current selection state on the question's options
    if (qIndex > -1) {
      var key = next.dataset.q;
      next.querySelectorAll('.kcq-opt').forEach(function (o) {
        o.classList.toggle('is-selected', answers[key] === o.dataset.val);
      });
    }
    try { next.focus({ preventScroll: true }); } catch (e) { next.focus(); }
    root.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
  }

  function nextOf(id) {
    if (id === 'intro') return 'q1';
    var i = QORDER.indexOf(id);
    if (i > -1 && i < QORDER.length - 1) return QORDER[i + 1];
    return 'result';
  }
  function prevOf(id) {
    var i = QORDER.indexOf(id);
    if (i <= 0) return 'intro';
    return QORDER[i - 1];
  }

  /* ---------- recommendation logic (from the brief) ---------- */
  function recommend(a) {
    var team = a.people === 'team', duo = a.people === 'duo', solo = a.people === 'solo';
    var p2d = a.p2d === 'yes', end = a.endurance === 'yes', storage = a.storage === 'yes';
    var primary;
    if (storage && (team || (p2d && end))) primary = 'premium';
    else if (p2d || solo || team) primary = 'starters';
    else if (duo) primary = 'duo';
    else primary = 'starters';

    var addons = [];
    if (team || end) addons.push('module');
    if (storage && primary !== 'premium') addons.push('case');
    if (primary === 'duo') addons.push('headset');
    // de-dupe + never suggest the primary as its own add-on, cap at 2
    addons = addons.filter(function (k, i) { return k !== primary && addons.indexOf(k) === i; }).slice(0, 2);
    return { primary: primary, addons: addons };
  }

  function mirror(a) {
    var m = I18N.mirror || {};
    var who = a.people === 'team' ? m.who_team : a.people === 'duo' ? m.who_duo : m.who_solo;
    var comms = a.p2d === 'yes' ? m.comms_yes : m.comms_no;
    var s = (who || '') + ', ' + (comms || '');
    if (a.endurance === 'yes') s += (m.end_yes || '');
    if (a.storage === 'yes') s += (m.storage_yes || '');
    return s + '.';
  }

  /* ---------- DOM helpers ---------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function media(box, p, alt) {
    if (!p.image) return;
    var img = el('img');
    img.src = p.image; img.alt = p.name || alt || ''; img.loading = 'lazy'; img.decoding = 'async';
    box.appendChild(img);
  }

  /* ---------- render result ---------- */
  function renderResult() {
    var rec = recommend(answers);
    var p = PRODUCTS[rec.primary];
    if (!p) return;

    root.querySelector('[data-result-mirror]').textContent = mirror(answers);
    var htpl = I18N.heading_tpl || 'You need the {product}.';
    root.querySelector('[data-result-heading]').textContent = htpl.replace('{product}', p.name);

    var main = root.querySelector('[data-result-main]');
    main.innerHTML = '';
    var panel = el('div', 'kcq-rec');
    if (p.image) { var m = el('div', 'kcq-rec__media'); media(m, p); panel.appendChild(m); }
    var body = el('div', 'kcq-rec__body');
    body.appendChild(el('h3', 'kcq-rec__name', p.name));
    if (p.price) body.appendChild(el('p', 'kcq-rec__price', p.price));
    if (p.why) body.appendChild(el('p', 'kcq-rec__why', p.why));
    var cta = el('a', 'kcq-btn kcq-rec__cta', p.cta || 'View product');
    cta.href = p.url || '#';
    body.appendChild(cta);
    panel.appendChild(body);
    main.appendChild(panel);

    var addonsWrap = root.querySelector('[data-result-addons]');
    var grid = root.querySelector('[data-addons-grid]');
    grid.innerHTML = '';
    var shown = 0;
    rec.addons.forEach(function (key) {
      var a = PRODUCTS[key];
      if (!a || !a.name) return;
      var card = el('div', 'kcq-addon');
      var mw = el('div', 'kcq-addon__media'); media(mw, a); card.appendChild(mw);
      var ab = el('div', 'kcq-addon__body');
      ab.appendChild(el('p', 'kcq-addon__name', a.name));
      if (a.why) ab.appendChild(el('p', 'kcq-addon__why', a.why));
      var foot = el('div', 'kcq-addon__foot');
      if (a.price) foot.appendChild(el('span', 'kcq-addon__price', a.price));
      var link = el('a', 'kcq-addon__link', (a.cta || 'View') + ' →');
      link.href = a.url || '#';
      foot.appendChild(link);
      ab.appendChild(foot);
      card.appendChild(ab);
      grid.appendChild(card);
      shown++;
    });
    addonsWrap.hidden = shown === 0;

    show('result');
  }

  /* ---------- wiring ---------- */
  var startBtn = root.querySelector('[data-start]');
  if (startBtn) startBtn.addEventListener('click', function () { show('q1'); });

  QORDER.forEach(function (id) {
    var screen = screens[id];
    if (!screen) return;
    var key = screen.dataset.q;
    screen.querySelectorAll('.kcq-opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        answers[key] = opt.dataset.val;
        screen.querySelectorAll('.kcq-opt').forEach(function (o) { o.classList.toggle('is-selected', o === opt); });
        var go = function () { var nx = nextOf(id); nx === 'result' ? renderResult() : show(nx); };
        reduce ? go() : setTimeout(go, 300);
      });
    });
    screen.querySelectorAll('[data-back]').forEach(function (b) {
      b.addEventListener('click', function () { show(prevOf(id), true); });
    });
  });

  var restart = root.querySelector('[data-restart]');
  if (restart) restart.addEventListener('click', function () {
    answers = {};
    root.querySelectorAll('.kcq-opt.is-selected').forEach(function (o) { o.classList.remove('is-selected'); });
    show('intro');
  });
})();
